// admin-analytics-expansion P4a (D9) — Ticket Trends API client
//
// getTicketTrends(params) → GET /admin/analytics/trends (org_admin | supervisor,
// same least-privilege scoping as ticket-analytics: locationId present →
// per-location, absent → org-wide/org_admin-only).
//
// Mirrors the shape of ticket-analytics.ts (buildQueryString + runtime-validated response).

import type { TicketTrendsQuery, TicketTrendsResponse } from '@jq4race/shared';
import { TicketTrendsResponseSchema } from '@jq4race/shared';

import { request } from './client.js';

function buildQueryString(params: TicketTrendsQuery): string {
  const entries: [string, string][] = [];
  if (params.locationId) entries.push(['locationId', params.locationId]);
  if (params.from) entries.push(['from', params.from]);
  if (params.to) entries.push(['to', params.to]);
  if (entries.length === 0) return '';
  return `?${entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')}`;
}

/**
 * GET /admin/analytics/trends
 *
 * Returns a daily-bucketed volume + net-revenue time-series (default 30-day
 * range when `from`/`to` are omitted). Empty days are zero-filled — never
 * omitted. Server-enforced least-privilege: supervisors may only request
 * their own assigned location (403 for org-wide or another location).
 */
export async function getTicketTrends(
  params: TicketTrendsQuery = {},
): Promise<TicketTrendsResponse> {
  const payload = await request<unknown>(`/admin/analytics/trends${buildQueryString(params)}`, {
    method: 'GET',
  });
  return TicketTrendsResponseSchema.parse(payload);
}
